import { VueHammer } from "vue2-hammer";
import Vue from "vue";
Vue.use(VueHammer);
